export const MOBILE_BREAKPOINT = 768
export const HEADER_HEIGHT = 52
export const SIDENAV_WIDTH = 260
export const CHAT_INTERFACE_BREAKPOINT = 450
